export class StaticRoute {
    public network: string;
    public gateway: string;
    public mtu: string;
    public isItNewlyAdded: boolean = false;
} 


// WEBPACK FOOTER //
// ./src/app/components/administration-main/interconnect-configuration/model/static-route.ts